import axios from "axios";

const API_URL = process.env.REACT_APP_BOT_NOTIFICATION_SERVICE_URL;

const toCompanyList = ({
  companies,
  tests,
  subscribedCompanies = [],
  subscribedTests = [],
}) =>
  companies.map((company) => {
    const isAllSubscribed = subscribedCompanies.includes(company.id);
    const subscribed =
      subscribedTests.find((s) => s.companyId === company.id)?.tests ?? [];

    return {
      CompanyId: company.id,
      CompanyName: company.name,
      Tests: tests.flatMap((group) =>
        group.tests.map((test) => ({
          TestId: test.id,
          TestName: test.name,
          Severity: test.severity,
          Subsystem: group.subsystem,
          IsSubscribed: isAllSubscribed || subscribed.includes(test.id),
        }))
      ),
    };
  });

export const getEquipmentHealthSubscriptions = async (userId) => {
  const response = await axios.get(`${API_URL}/subscription/${userId}`, {
    headers: { "X-Api-Key": process.env.REACT_APP_BOT_NOTIFICATION_API_KEY },
  });

  return toCompanyList(response.data);
};

// Companies with every test selected go to subscribedCompanies; partial selections go to subscribedTests.
const toUpdatePayload = (companies, selection) => {
  const subscribedCompanies = [];
  const subscribedTests = [];

  companies.forEach((company) => {
    const selected = selection[company.CompanyId] ?? [];
    if (selected.length === 0) return;

    if (selected.length === company.Tests.length) {
      subscribedCompanies.push(company.CompanyId);
    } else {
      subscribedTests.push({ companyId: company.CompanyId, tests: selected });
    }
  });

  return { subscribedCompanies, subscribedTests };
};

// Replaces the user's whole subscription state; selection: { [companyId]: testId[] }
export const updateEquipmentHealthSubscriptions = async (
  userId,
  companies,
  selection
) => {
  const payload = toUpdatePayload(companies, selection);

  const response = await axios.put(`${API_URL}/subscription/${userId}`, payload, {
    headers: { "X-Api-Key": process.env.REACT_APP_BOT_NOTIFICATION_API_KEY },
  });

  return response.data;
};
